import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfigService } from '../../config.service';
import { BranchService } from '../../services/branch.service';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'app-shell',
  imports: [
    RouterOutlet
  ],
  templateUrl: './shell.html'
})
export class ShellComponent implements OnInit {
  env = '';
  whoami = 'User';
  production = false;
  homeUrl: string | null = null;
  selectedBranch: string | null = null;

  private readonly profileService = inject(ProfileService);
  private readonly configService = inject(ConfigService);
  private readonly branchService = inject(BranchService);

  constructor() {
    this.production = this.configService.production;
    this.env = this.configService.env;
  }

  ngOnInit(): void {
    this.profileService.whoami$.subscribe(name => {
      this.whoami = name;
    })
    this.homeUrl = this.configService.homeUrl;

    this.branchService.getSelectedBranch().subscribe(branch => {
      this.selectedBranch = branch?.fullBranchName ?? '';
    })
  }

  logout(): void {
    void this.profileService.logout();
  }
}
